// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"509":"342db3a7","652":"343ce43f"}[chunkId] + ".chunk.js";
};